<div class="variant-main-div">
  <div class="back-btn" (click)="goToYear()">
        <mat-icon class="go-back-to-year">keyboard_arrow_left</mat-icon>
        <div class="breadcrumb">
        Make <span>&gt;</span> Model <span>&gt;</span> Year <span>&gt;</span> <b>Variant</b>
    </div>
  </div>  
  <div class="container">

    <h2>Which variant of {{ selectedModel }}?</h2>
    <p>Select the specific variant of your vehicle for accurate service recommendations</p>

    <div class="search-box">
        <mat-icon class="material-icons">search</mat-icon>
        <input type="text" [(ngModel)]="searchText" placeholder="Search for variant">
        <mat-icon class="material-icons close-btn" *ngIf="searchText" (click)="clearSearch()">close</mat-icon>
    </div>
    

    <div class="fuel-tabs" role="tablist">
        <button [class.active]="selectedFuel==='Petrol'" (click)="selectFuel('Petrol')">⛽ Petrol</button>
        <button [class.active]="selectedFuel==='Diesel'" (click)="selectFuel('Diesel')">⚡ Diesel</button>
        <!-- <button [class.active]="selectedFuel==='CNG'" (click)="selectFuel('CNG')">🟢 CNG</button> -->
    </div>

    <div class="variants" *ngIf="filteredVariants.length > 0; else noVariants">
    <div class="variant-card" *ngFor="let v of filteredVariants" 
        (click)="selectVariant(v.variantKey, v.title, v.fuelType)">
        <h4>★ {{ v.title }}</h4>
        <p>{{ v.description }}</p>
        <span class="check">✔</span>
    </div>
    </div>

    <ng-template #noVariants>
    <p class="no-variants">No variants available for the selected vehicle.</p>
    </ng-template>


    <ng-template #noVariants>
    <p class="no-variants">No variants available for the selected vehicle.</p>
    </ng-template>

    </div>
</div>
